module.exports = __webpack_public_path__ + "img/award-explain.0f97f2f2.png";